import React from 'react';
import IllustrationState from '.';
import FailedImage from '../../../assets/icon/illustrations_error_failed_connection.svg';
import EmptyIcon from '../../../assets/icon/illustrations_no-document.svg';
import { Image } from '@mantine/core';
import { IllustrationProps } from './SuccessIllustration';

const FailedIllustration: React.FC<IllustrationProps> = ({
  description = 'Something went wrong, please try again later.',
  title = 'Failed to load data',
  titleSize,
  descriptionSize,
  span,
  theme,
  heightImage,
  widthImage = 200
}) => {
  return (
    <>
      <IllustrationState
        Illustration={
          <Image src={FailedImage} w={widthImage} h={heightImage} />
        }
        description={description}
        descriptionColor={theme?.colors?.text}
        title={title}
        titleColor={theme?.colors?.text}
        titleSize={titleSize}
        descriptionSize={descriptionSize}
        span={span}
      />
    </>
  );
};

export default FailedIllustration;
